import { AlertCircle, ExternalLink } from 'lucide-react'
import { Link } from 'react-router-dom'

import { Alert, AlertDescription } from '@/components/ui/alert'
import {
  AUTOMATION_TEMPLATE_UI,
  META_TEMPLATE_ALERT_CLASS,
} from '@/components/settings/automationTemplatesUi'

type AutomationTemplateMetaAlertsProps = {
  lang: string
  metaIntegrationEnabled: boolean
  whatsappConnected: boolean
  whatsappStatusLoading?: boolean
  serviceUnavailable?: boolean
  serviceUnavailableMessage?: string
}

export function AutomationTemplateMetaAlerts({
  lang,
  metaIntegrationEnabled,
  whatsappConnected,
  whatsappStatusLoading = false,
  serviceUnavailable = false,
  serviceUnavailableMessage = AUTOMATION_TEMPLATE_UI.serviceUnavailableMessage,
}: AutomationTemplateMetaAlertsProps) {
  const settingsHref = `/${lang}/settings`

  return (
    <>
      {serviceUnavailable ? (
        <Alert className={META_TEMPLATE_ALERT_CLASS}>
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>{serviceUnavailableMessage}</AlertDescription>
        </Alert>
      ) : null}

      {!metaIntegrationEnabled ? (
        <Alert className={META_TEMPLATE_ALERT_CLASS}>
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>{AUTOMATION_TEMPLATE_UI.metaDisabledMessage}</AlertDescription>
        </Alert>
      ) : null}

      {metaIntegrationEnabled && !whatsappStatusLoading && !whatsappConnected ? (
        <Alert className={META_TEMPLATE_ALERT_CLASS}>
          <AlertCircle className="h-4 w-4" />
          <AlertDescription className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <span>{AUTOMATION_TEMPLATE_UI.whatsappRequiredMessage}</span>
            <Link
              to={settingsHref}
              className="inline-flex items-center gap-1 font-medium text-primary underline-offset-4 hover:underline"
            >
              {AUTOMATION_TEMPLATE_UI.settingsLinkLabel}
              <ExternalLink className="h-3.5 w-3.5" />
            </Link>
          </AlertDescription>
        </Alert>
      ) : null}
    </>
  )
}
